module.exports = __webpack_public_path__ + "img/Capture - 2_2.32756363.png";